import React, { Component } from "react";
import Classnames from "classnames";
import { ReactComponent as TwoNLogo } from "./two-n-logo.svg";
import "./Section.scss";
import Card from "../Card";

import { nestedData, section } from "../../global-interfaces";
import { TEXT, NESTED_TEXT, INTRODUCTION, SUBHEADER } from "../../constants";
import TextCard from "../TextCard";

interface Props {
  data: nestedData;
  setSection: Function;
  observer: IntersectionObserver;
  inView: { [key: string]: boolean };
  isMobile: boolean;
  isLast: boolean;
}

class Section extends Component<Props> {
  section: section;
  constructor(props: Props) {
    super(props);
    const { title, color, hash, index, path, pathActive } = this.props.data;
    this.section = { title, color, hash, index, path, pathActive };
  }

  shouldComponentUpdate(nextProps: Props) {
    return (
      JSON.stringify({ ...nextProps.inView }) !==
      JSON.stringify({ ...this.props.inView })
    );
  }

  render() {
    const { setSection, observer, inView, isMobile, isLast } = this.props;
    const {
      cards,
      title,
      color,
      hash,
      index,
      path,
      pathActive,
    } = this.props.data;

    return (
      <div className={Classnames("Section", color)} id={hash}>
        <div className="section-title">{title}</div>
        {cards.map(d => {
          return d.questions[0].chart_type === TEXT ||
            d.questions[0].chart_type === NESTED_TEXT ||
            d.questions[0].chart_type === SUBHEADER ? (
            <TextCard
              key={d.card}
              type={d.questions[0].chart_type}
              data={d.questions[0].data}
              title={d.questions[0].graph_title}
              card={d.questions[0].card}
              section={{ title, color, hash, index, path, pathActive }}
              introCard={
                title === INTRODUCTION && d.questions[0].chart_type === "text"
              }
              setSection={setSection}
              observer={observer}
            />
          ) : (
            <Card
              key={d.card}
              data={d.questions}
              section={this.section}
              observer={observer}
              inView={inView ? inView[d.card] : false}
              isMobile={isMobile}
            />
          );
        })}
        {isLast && (
          <div className="two-n-logo">
            <span>designed and developed by </span>
            <a href="http://two-n.com/" target="_blank" tabIndex={-1}>
              <TwoNLogo />
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default Section;
